import { ProductLine } from '@core/models/swagger';
import { MultiQuoteResponse, SearchPartnerResponse } from '@core/models/swagger/bff';
import { createAction, props } from '@ngrx/store';

export enum GeneralActions {
  ResetGeneral = '[Flow Data General] Reset general',
  UpdateSelectedProductLine = '[Flow Data General] Update Selected Product Line',
  UpdatePartnerSearchResponse = '[Flow Data General] Update partner search response',
  UpdateProgressId = '[Flow Data General] Update progress id',
  UpdateFullOperationId = '[Flow Data General] Update full operation id',
  UpdateQuotingId = '[Runtime] Update quoting id',
  UpdateProductLines = '[Flow Data General] Update offered Product Lines',
  UpdatePrevUrl = '[Flow Data General] Update previouse url',
}

export const ResetGeneral = createAction(GeneralActions.ResetGeneral);

export const UpdateSelectedProductLine = createAction(
  GeneralActions.UpdateSelectedProductLine,
  props<{ data: ProductLine }>()
);

export const UpdatePartnerSearchResponse = createAction(
  GeneralActions.UpdatePartnerSearchResponse,
  props<{ data: SearchPartnerResponse }>()
);

export const UpdateProgressId = createAction(GeneralActions.UpdateProgressId, props<{ data: number }>());

export const UpdateFullOperationId = createAction(GeneralActions.UpdateFullOperationId, props<{ data: string }>());

export const UpdateQuotingId = createAction(GeneralActions.UpdateQuotingId, props<{ data: string }>());

export const UpdateProductLines = createAction(
  GeneralActions.UpdateProductLines,
  props<{ data: MultiQuoteResponse }>()
);

export const UpdatePrevUrl = createAction(GeneralActions.UpdatePrevUrl, props<{ data: string }>());
